import React, { useState, useEffect } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import StateSiteUserPublisher from "./StateSiteUserPublisher";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";

export default function InfoSite() {
  const [userSitePublisher, setUserSitePublisher] = useState();
  const params = useParams();
  const sitePublisherID = params.sitePublisherID;
  const history = useHistory();
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    getUserSitePublisher();
  }, []);

  const getUserSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let userSitePublisher = await sendRequestGetUserSitePublisher(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!userSitePublisher) {
      return;
    }
    const htmlTag = `<script class="hilite-script" data-hilite="${userSitePublisher.hashIDScript}" src="https://unpkg.com/hilite-script-site-publisher@latest/dist/script.min.js"></script>`;

    setUserSitePublisher({
      ...userSitePublisher,
      htmlTag: htmlTag,
    });
  };

  const reCheckUserSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultReCheckUserSitePublisher =
      await sendRequestReCheckUserSitePublisher(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultReCheckUserSitePublisher) {
      return;
    }
    history.push(`/site/all`);
  };

  const sendRequestReCheckUserSitePublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/publisher/site/" +
          sitePublisherID +
          "/recheck",
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetUserSitePublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderRequest();
    let siteUserPublisher;
    try {
      siteUserPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/publisher/site/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return siteUserPublisher.data.data;
  };

  const generateUserSitePublisherInfo = () => {
    let classNameBadgeType = "";
    switch (userSitePublisher.state) {
      case StateSiteUserPublisher.statusSiteUserPublisher.PENDING:
        classNameBadgeType += "warning";
        break;
      case StateSiteUserPublisher.statusSiteUserPublisher.CONFIRM:
        classNameBadgeType = "success";
        break;
      case StateSiteUserPublisher.statusSiteUserPublisher.REJECT:
        classNameBadgeType = "danger";
        break;
    }
    return (
      <>
        <div className="text-left pb-2">
          <Link className="btn btn-primary" to="/site/all">
            <span>بازگشت</span>
            <span className="pr-2">
              <i className="fas fa-arrow-left"></i>
            </span>
          </Link>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite m-0">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  <b>اطلاعات سایت نمایش دهنده شما</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره سایت نمایش دهنده</td>
                <td>{userSitePublisher.id}</td>
              </tr>
              <tr>
                <td>آدرس سایت</td>
                <td>
                  <a target="_blank" href={userSitePublisher.url}>
                    {userSitePublisher.url}
                  </a>
                </td>
              </tr>
              <tr>
                <td>حالت</td>
                <td>
                  <span className={`badge  badge-${classNameBadgeType}`}>
                    {userSitePublisher.state}
                  </span>
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <span
                    className={`
                        badge badge-${
                          userSitePublisher.active ==
                          StateSiteUserPublisher.getActiveSiteUserPublisherString()[
                            StateSiteUserPublisher.activeSiteUserPublisher
                              .ACTIVE
                          ]
                            ? "success"
                            : "danger"
                        }
                        `}
                  >
                    {userSitePublisher.active}
                  </span>
                </td>
              </tr>
              <tr>
                <td>پیغام</td>
                <td>{userSitePublisher.message}</td>
              </tr>
              <tr>
                <td>اسکریپت</td>
                <td dir="ltr" className="text-left">
                  <span className="pr-2">{userSitePublisher.htmlTag}</span>
                  <span>
                    <button
                      className="btn btn-info"
                      onClick={(e) => {
                        e.preventDefault();
                        navigator.clipboard.writeText(
                          userSitePublisher.htmlTag
                        );
                        setCopied(true);
                      }}
                    >
                      <i className="fas fa-copy pr-2"></i>
                      {copied ? "کپی شد" : " کپی  "}{" "}
                    </button>
                  </span>
                </td>
              </tr>
              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helpersNumbers.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      userSitePublisher.created_at.split(" ")[0]
                    ) +
                      " " +
                      userSitePublisher.created_at.split(" ")[1]
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="pt-2">
          {StateSiteUserPublisher.statusSiteUserPublisher.REJECT ===
          userSitePublisher.state ? (
            <button
              className="btn btn-success"
              onClick={(e) => {
                e.preventDefault();
                reCheckUserSitePublisher();
              }}
            >
              ارسال درخواست بررسی دوباره
            </button>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اطلاعات سایت ها نمایش دهنده شما" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {userSitePublisher && generateUserSitePublisherInfo()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
